import { render } from "./SecurityService.vue?vue&type=template&id=0c023ba2&scoped=true"
import script from "./SecurityService.vue?vue&type=script&lang=js"
export * from "./SecurityService.vue?vue&type=script&lang=js"

import "./SecurityService.vue?vue&type=style&index=0&id=0c023ba2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c023ba2"

export default script